import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/comensal-4-pago.webp")